import React from "react";
import { useSettings } from "@/library/lib/settings";
import { Phone, Code2 } from "lucide-react";

const CreditBar = () => {
  const s = useSettings();
  if (!s.credit_text) return null;
  return (
    <div data-testid="credit-bar" className="bg-brand-dark text-white/90 py-3 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-center gap-3 text-xs sm:text-sm">
        <div className="flex items-center gap-2">
          <Code2 className="w-4 h-4 text-gold-light" />
          <span className="font-semibold">{s.credit_text}</span>
        </div>
        {s.credit_phone && (
          <>
            <span className="hidden sm:inline text-white/30">•</span>
            <a href={`tel:${s.credit_phone}`} className="flex items-center gap-2 hover:text-gold-light transition-colors">
              <Phone className="w-4 h-4 text-gold-light" />
              <span dir="ltr" className="font-mono tabular-nums tracking-wider">{s.credit_phone}</span>
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default CreditBar;
